import { useEffect, useState } from "react";

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(
    () => window.matchMedia(query).matches,
  );
  const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    mediaQuery.addEventListener("change", handler);

    return () => mediaQuery.removeEventListener("change", handler);
  }, [query]);

  return matches;
}
